import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import './index.css';
import './range.css';

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet>
      <title>Line.fm 𝘾𝙡𝙖𝙨𝙨𝙞𝙘</title>
      <meta property="og:url" content="https://classic.line.fm" />
      <meta property="og:image" content="https://classic.line.fm/static/Favicon@4x.png" />
      <meta property="og:title" content="Line.fm 𝘾𝙡𝙖𝙨𝙨𝙞𝙘" />
      <meta
        property="og:description"
        content="Good tunes on autopilot 🎵✈️😎. Listen to all tunes from @wipmusic. (RIP)"
      />
      <meta name="twitter:card" content="summary" />
    </Helmet>
    {children()}
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js